(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (un solo observer) ---------- */
  var revealObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); revealObs.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function initReveals(root) {
    (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      if (!revealObs || reduce) { el.classList.add('mt-visible'); return; }
      revealObs.observe(el);
    });
  }

  /* ---------- Héroe carrusel ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      if (hero.dataset.mtInit) return; hero.dataset.mtInit = '1';
      var slides = hero.querySelectorAll('.mt-hero__slide');
      var dots = hero.querySelectorAll('.mt-hero__dot');
      if (slides.length < 2) return;
      var dur = parseInt(hero.dataset.dur, 10) || 6000;
      var auto = hero.dataset.auto === 'true' && !reduce;
      var idx = 0, timer = null;
      hero.style.setProperty('--mt-dur', dur + 'ms');
      function go(n) {
        slides[idx].classList.remove('is-active'); dots[idx] && dots[idx].classList.remove('is-active');
        slides[idx].setAttribute('aria-hidden', 'true');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active'); slides[idx].removeAttribute('aria-hidden');
        if (dots[idx]) { dots[idx].classList.remove('is-active'); void dots[idx].offsetWidth; dots[idx].classList.add('is-active'); }
        restart();
      }
      function restart() { if (!auto) return; clearTimeout(timer); timer = setTimeout(function () { go(idx + 1); }, dur); }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      hero.addEventListener('mouseenter', function () { if (!auto) return; clearTimeout(timer); hero.classList.add('is-paused'); });
      hero.addEventListener('mouseleave', function () { if (!auto) return; hero.classList.remove('is-paused'); restart(); });
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) go(idx + (dx < 0 ? 1 : -1));
      });
      restart();
    });
  }

  /* ---------- Quiz ---------- */
  function initQuiz(root) {
    (root || document).querySelectorAll('[data-mt-quiz]').forEach(function (quiz) {
      if (quiz.dataset.mtInit) return; quiz.dataset.mtInit = '1';
      var panels = quiz.querySelectorAll('.mt-quiz__panel');
      var bars = quiz.querySelectorAll('.mt-quiz__steps span');
      var results = quiz.querySelectorAll('.mt-quiz__result');
      var answers = [];
      function show(step) {
        panels.forEach(function (p, i) { p.classList.toggle('is-active', i === step); });
        bars.forEach(function (b, i) { b.classList.toggle('is-done', i < step || (step === -1)); });
        if (step !== -1) results.forEach(function (r) { r.classList.remove('is-active'); });
      }
      quiz.querySelectorAll('.mt-quiz__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.step, 10);
          answers[step] = btn.dataset.value;
          btn.parentNode.querySelectorAll('.mt-quiz__opt').forEach(function (o) { o.classList.toggle('is-selected', o === btn); });
          setTimeout(function () {
            if (step + 1 < panels.length) { show(step + 1); return; }
            show(-1);
            var key = answers.join('-');
            results.forEach(function (r) { r.classList.toggle('is-active', r.dataset.key === key); });
          }, 260);
        });
      });
      quiz.querySelectorAll('[data-mt-back]').forEach(function (b) {
        b.addEventListener('click', function () { show(Math.max(0, parseInt(b.dataset.mtBack, 10))); });
      });
      quiz.querySelectorAll('[data-mt-restart]').forEach(function (b) {
        b.addEventListener('click', function () {
          answers = []; quiz.querySelectorAll('.mt-quiz__opt').forEach(function (o) { o.classList.remove('is-selected'); });
          show(0);
        });
      });
    });
  }

  /* ---------- Manifiesto: palabra a palabra ---------- */
  var maniList = [];
  function initManifiesto(root) {
    (root || document).querySelectorAll('[data-mt-mani]').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      var words = el.querySelectorAll('.mt-w');
      if (reduce || el.dataset.efecto !== 'true') { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
      maniList.push({ el: el, words: words });
    });
    onScroll();
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      maniList.forEach(function (m) {
        var r = m.el.getBoundingClientRect();
        // empieza cuando el texto entra por abajo y acaba al llegar al 35% superior
        var p = (vh * 0.85 - r.top) / (r.height + vh * 0.5);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * m.words.length);
        m.words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
      });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Acordeones (FAQ y producto) ---------- */
  function initAcordeones(root) {
    (root || document).querySelectorAll('[data-mt-acc]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return; wrap.dataset.mtInit = '1';
      var single = wrap.dataset.mtAcc === 'single';
      wrap.querySelectorAll('.mt-faq__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.mt-faq__item');
          var open = !item.classList.contains('is-open');
          if (single) wrap.querySelectorAll('.mt-faq__item.is-open').forEach(function (o) {
            if (o !== item) { o.classList.remove('is-open'); o.querySelector('.mt-faq__q').setAttribute('aria-expanded', 'false'); }
          });
          item.classList.toggle('is-open', open);
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-pdp]').forEach(function (pdp) {
      if (pdp.dataset.mtInit) return; pdp.dataset.mtInit = '1';

      // Galería
      var main = pdp.querySelector('.mt-pdp__main');
      var mainImg = main && main.querySelector('img');
      pdp.querySelectorAll('.mt-pdp__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          pdp.querySelectorAll('.mt-pdp__thumb').forEach(function (o) { o.classList.toggle('is-active', o === t); });
          if (!mainImg) return;
          mainImg.style.opacity = 0;
          setTimeout(function () {
            mainImg.src = t.dataset.src; mainImg.srcset = t.dataset.srcset || ''; mainImg.alt = t.dataset.alt || '';
            mainImg.style.opacity = 1;
          }, 180);
        });
      });
      // Celular: un toque acerca y otro toque aleja (en el punto tocado)
      var mtToque = false;
      if (main) {
        main.addEventListener('pointerdown', function (e) { mtToque = e.pointerType !== 'mouse'; });
        main.addEventListener('click', function (e) {
          if (!mtToque) return;
          var r = main.getBoundingClientRect();
          if (!main.classList.contains('is-zoom')) {
            main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
            main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
          }
          main.classList.toggle('is-zoom');
        });
      }
      if (main && window.matchMedia('(hover: hover)').matches) {
        main.addEventListener('mousemove', function (e) {
          if (mtToque) return;
          var r = main.getBoundingClientRect();
          main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
        main.addEventListener('mouseenter', function () { if (!mtToque) main.classList.add('is-zoom'); });
        main.addEventListener('mouseleave', function () { if (!mtToque) main.classList.remove('is-zoom'); });
      }

      // Fecha estimada de llegada: N días hábiles (no cuenta domingos)
      var llegada = pdp.querySelector('[data-mt-llegada]');
      if (llegada) {
        var envP = llegada.parentNode, dias = parseInt(envP.dataset.dias, 10) || 6;
        var hoy = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
        var d = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
        while (dias > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) dias--; }
        var dn = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
        var mn = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
        var fecha = dn[d.getDay()] + ' ' + d.getDate() + ' de ' + mn[d.getMonth()];
        var mtPintarLlegada = function () {
          var llega = envP.dataset.txtLlega || '';
          var antes = envP.classList.contains('is-gratis') ? envP.dataset.txtGratis + (llega ? ', ' + llega : ',') : (llega ? llega.charAt(0).toUpperCase() + llega.slice(1) : '');
          llegada.textContent = antes + ' ';
          var b = document.createElement('strong'); b.textContent = fecha; llegada.appendChild(b);
        };
        mtPintarLlegada();
        pdp.mtPintarLlegada = mtPintarLlegada;
      }

      // Cantidad
      var qty = pdp.querySelector('.mt-pdp__qty input');
      pdp.querySelectorAll('[data-mt-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.mtQty, 10);
          var tope = parseInt(qty.getAttribute('max'), 10);
          qty.value = Math.max(1, tope ? Math.min(tope, v) : v);
          if (pdp.mtPrecio) pdp.mtPrecio();
        });
      });

      // Precio en vivo: precio × cantidad, con la promoción dúo en mists y cremas.
      // El precio de dúo sale si se eligen 2 o más en la cantidad, o si ya hay 2 o más en el carrito
      // (con 1 en el carrito y 1 elegido se muestra el precio normal).
      var duoEl = pdp.querySelector('[data-mt-duo]');
      var pPrice = pdp.querySelector('[data-mt-price]'), pCompare = pdp.querySelector('[data-mt-compare]');
      var pFmt = pdp.dataset.moneyFormat || '${{amount}}';
      var pMoney = function (c) { return pFmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); };
      var duoEnCarrito = duoEl ? (parseInt(duoEl.dataset.enCarrito, 10) || 0) : 0, duoIds = null;
      var duoTxt = duoEl && duoEl.querySelector('[data-mt-duo-txt]');
      // Estados: base (nada en el carrito) · uno (1 en el carrito) · activo (2 o más, en carrito o elegidos) con palomita
      pdp.mtDuoEstado = function (n) {
        if (!duoEl || !duoTxt) return;
        var estado = (duoEnCarrito >= 2 || n >= 2) ? 'activo' : (duoEnCarrito === 1 ? 'uno' : 'base');
        if (duoEl.dataset.estado === estado) return;
        duoEl.dataset.estado = estado;
        var texto = estado === 'activo' ? duoEl.dataset.txtActivo : estado === 'uno' ? duoEl.dataset.txtUno : duoEl.dataset.txtBase;
        clearTimeout(duoEl.mtT);
        duoEl.classList.add('is-cambiando');
        duoEl.mtT = setTimeout(function () {
          duoTxt.textContent = texto;
          duoEl.classList.toggle('is-activo', estado === 'activo');
          duoEl.classList.remove('is-cambiando');
        }, 220);
      };
      pdp.mtPrecio = function () {
        var precio = parseInt(pdp.dataset.precio, 10) || 0, compare = parseInt(pdp.dataset.compare, 10) || 0;
        var n = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
        var monto = duoEl ? (parseInt(duoEl.dataset.duoMonto, 10) || 0) : 0;
        var duo = monto > 0 && (n >= 2 || duoEnCarrito >= 2) && precio > monto;
        var unidad = duo ? precio - monto : precio;
        var tachado = duo ? precio : (compare > precio ? compare : 0);
        if (pPrice) pPrice.textContent = pMoney(unidad * n);
        if (pCompare) pCompare.textContent = tachado ? pMoney(tachado * n) : '';
        if (pdp.mtDuoEstado) pdp.mtDuoEstado(n);
        var cantEl = pdp.querySelector('[data-mt-cant]');
        if (cantEl) { cantEl.textContent = 'x' + n; cantEl.hidden = n < 2; }
        var envioEl = pdp.querySelector('[data-mt-envio]');
        if (envioEl) {
          var gratis = precio >= (parseInt(pdp.dataset.envioGratis, 10) || 150000);
          if (gratis !== envioEl.classList.contains('is-gratis')) { envioEl.classList.toggle('is-gratis', gratis); if (pdp.mtPintarLlegada) pdp.mtPintarLlegada(); }
        }
      };
      if (qty) {
        qty.addEventListener('input', pdp.mtPrecio);
        qty.addEventListener('change', function () {
          var tope = parseInt(qty.getAttribute('max'), 10), n = parseInt(qty.value, 10) || 1;
          if (tope && n > tope) qty.value = tope;
          if (n < 1) qty.value = 1;
          pdp.mtPrecio();
        });
      }
      if (duoEl) {
        var duoContar = function () {
          var ids = duoIds ? Promise.resolve(duoIds) : Promise.all(duoEl.dataset.duoColeccion.replace(/\s/g, '').split(',').filter(Boolean).map(function (h) {
            return fetch('/collections/' + h + '/products.json?limit=250').then(function (r) { return r.json(); }).catch(function () { return {}; });
          })).then(function (listas) {
            duoIds = [];
            listas.forEach(function (j) { (j.products || []).forEach(function (p) { if (duoIds.indexOf(p.id) < 0) duoIds.push(p.id); }); });
            return duoIds;
          });
          Promise.all([ids, fetch('/cart.js').then(function (r) { return r.json(); })]).then(function (res) {
            duoEnCarrito = (res[1].items || []).reduce(function (n, i) { return n + (res[0].indexOf(i.product_id) > -1 ? i.quantity : 0); }, 0);
            pdp.mtPrecio();
          }).catch(function () {});
        };
        document.addEventListener('mt:carrito', duoContar);
        duoContar();
      }

      // Variantes
      var dataEl = pdp.querySelector('[data-mt-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = pdp.querySelector('input[name="id"]');
      var btn = pdp.querySelector('.product-form__submit');
      var btnText = btn && btn.querySelector('span');
      var priceEl = pdp.querySelector('[data-mt-price]');
      var compareEl = pdp.querySelector('[data-mt-compare]');
      var stockEl = pdp.querySelector('.mt-pdp__stock');
      var fmt = pdp.dataset.moneyFormat || '${{amount}}';
      function money(cents) {
        var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
      }
      pdp.querySelectorAll('.mt-pdp__opt input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          pdp.querySelectorAll('.mt-pdp__opt').forEach(function (fs) {
            var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
          });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) {
            if (btn) { btn.setAttribute('aria-disabled', 'true'); btnText.textContent = pdp.dataset.txtNa; }
            return;
          }
          idInput.value = v.id;
          pdp.dataset.precio = v.price; pdp.dataset.compare = v.compare_at_price || 0;
          var qtyV = pdp.querySelector('.mt-pdp__qty input');
          if (qtyV) {
            if (v.stock) { qtyV.setAttribute('max', v.stock); if ((parseInt(qtyV.value, 10) || 1) > v.stock) qtyV.value = v.stock; }
            else qtyV.removeAttribute('max');
          }
          pdp.mtPrecio();
          if (btn) {
            if (v.available) { btn.removeAttribute('aria-disabled'); btn.disabled = false; btnText.textContent = pdp.dataset.txtAdd; }
            else { btn.setAttribute('aria-disabled', 'true'); btnText.textContent = pdp.dataset.txtOut; }
          }
          if (stockEl) {
            stockEl.classList.toggle('is-out', !v.available);
            stockEl.classList.toggle('is-pocos', !!v.pocos);
            stockEl.querySelector('span').textContent = !v.available ? pdp.dataset.txtOut
              : v.pocos === 1 ? pdp.dataset.txtPocosUno
              : v.pocos ? pdp.dataset.txtPocos.replace('[n]', v.pocos)
              : pdp.dataset.txtIn;
          }
          if (v.featured_image && mainImg) { mainImg.src = v.featured_image; mainImg.srcset = ''; }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  /* ---------- Pestañas de productos ---------- */
  function initPestanas(root) {
    (root || document).querySelectorAll('[data-mt-tabs]').forEach(function (w) {
      if (w.dataset.mtInit) return; w.dataset.mtInit = '1';
      var tabs = w.querySelectorAll('.mt-tabs__tab');
      var panels = w.querySelectorAll('.mt-tabs__panel');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o, j) { o.classList.toggle('is-active', j === i); o.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
        });
      });
    });
  }

  /* ---------- Elige por notas ---------- */
  function initNotas(root) {
    (root || document).querySelectorAll('[data-mt-notas]').forEach(function (w) {
      if (w.dataset.mtInit) return; w.dataset.mtInit = '1';
      var tabs = w.querySelectorAll('.mt-notas__tabs .mt-tabs__tab');
      var panels = w.querySelectorAll('.mt-notas__panel');
      var input = w.querySelector('[data-mt-notas-buscar]');
      var toggle = w.querySelector('[data-mt-notas-toggle]');
      // En ordenador el bloque sale abierto aunque no haya nada elegido (en celular se queda como está)
      if (toggle && window.matchMedia('(min-width: 990px)').matches && !w.classList.contains('is-open')) {
        var cuerpo = w.querySelector('.mt-notas__body');
        if (cuerpo) cuerpo.style.transition = 'none';
        w.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (cuerpo) requestAnimationFrame(function () { requestAnimationFrame(function () { cuerpo.style.transition = ''; }); });
      }
      if (toggle) toggle.addEventListener('click', function () {
        var open = w.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      function activo() { return w.querySelector('.mt-notas__panel.is-active'); }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.grupo === t.dataset.grupo); });
          if (input) filtrar();
        });
      });
      w.querySelectorAll('[data-mt-notas-mas]').forEach(function (b) {
        var txt = b.textContent;
        b.addEventListener('click', function () {
          var chips = b.parentNode.querySelector('.mt-notas__chips');
          var abierto = chips.classList.toggle('is-open');
          b.textContent = abierto ? b.dataset.txtMenos : txt;
        });
      });
      function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
      function filtrar() {
        var q = norm(input.value.trim());
        panels.forEach(function (p) {
          var chips = p.querySelector('.mt-notas__chips');
          var mas = p.querySelector('[data-mt-notas-mas]');
          var vacio = p.querySelector('.mt-notas__vacio');
          var hits = 0;
          chips.classList.toggle('is-filtering', q.length > 0);
          chips.querySelectorAll('.mt-chip').forEach(function (c) {
            var ok = q.length > 0 && norm(c.dataset.nombre).indexOf(q) !== -1;
            c.classList.toggle('is-match', ok); if (ok) hits++;
          });
          if (mas) mas.hidden = q.length > 0;
          if (vacio) vacio.hidden = !(q.length > 0 && hits === 0);
        });
      }
      if (input) input.addEventListener('input', filtrar);
    });
  }

  /* ---------- Productos complementarios (Search & Discovery) ---------- */
  function initRecos(root) {
    (root || document).querySelectorAll('[data-mt-recos]').forEach(function (el) {
      if (el.dataset.mtInit || el.querySelector('[data-mt-recos-contenido]')) return; el.dataset.mtInit = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var c = doc.querySelector('[data-mt-recos-contenido]');
        if (!c) return;
        el.innerHTML = '';
        el.appendChild(c);
        initReveals(el);
      }).catch(function () {});
    });
  }

  /* ---------- Carrito: protección de envío ---------- */
  function mtProteccion(variantId, key, agregar, enCajon) {
    var drawer = document.querySelector('cart-drawer');
    var secciones = 'cart-drawer,cart-icon-bubble';
    var url = agregar ? window.routes.cart_add_url + '.js' : window.routes.cart_change_url + '.js';
    var body = agregar ? { items: [{ id: Number(variantId), quantity: 1 }], sections: secciones } : { id: key, quantity: 0, sections: secciones };
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (enCajon && drawer && res.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        else { window.location.reload(); }
      });
  }
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('.mt-prot__check');
    if (!cb) return;
    var box = cb.closest('[data-mt-prot]');
    box.classList.add('is-loading');
    mtProteccion(box.dataset.variant, box.dataset.key, cb.checked, !!cb.closest('cart-drawer'))
      .catch(function () { window.location.reload(); });
  });
  // Si en el carrito solo queda la protección, se quita sola
  var mtLimpiando = false;
  function mtRevisarSolo() {
    var solo = document.querySelector('[data-mt-prot-solo]');
    if (!solo || mtLimpiando) return;
    mtLimpiando = true;
    mtProteccion(null, solo.dataset.key, false, !!solo.closest('cart-drawer')).finally(function () { mtLimpiando = false; });
  }
  new MutationObserver(mtRevisarSolo).observe(document.documentElement, { childList: true, subtree: true });
  mtRevisarSolo();

  /* ---------- Carrito: oferta del atomizador (flecha + agregar) ---------- */
  var mtUpAbierto = false;
  function mtUpAplicar() {
    document.querySelectorAll("[data-mt-up]").forEach(function (box) {
      var btn = box.querySelector("[data-mt-up-toggle]"), lista = box.querySelector(".mt-up__lista");
      if (!btn || !lista) return;
      if (btn.getAttribute("aria-expanded") === String(mtUpAbierto)) return;
      btn.setAttribute("aria-expanded", mtUpAbierto ? "true" : "false");
      box.classList.toggle("is-open", mtUpAbierto);
      lista.hidden = !mtUpAbierto;
    });
  }
  document.addEventListener("click", function (e) {
    var cab = e.target.closest && e.target.closest(".mt-up__cab"), t = cab && cab.querySelector("[data-mt-up-toggle]");
    if (t) { mtUpAbierto = t.getAttribute("aria-expanded") !== "true"; mtUpAplicar(); return; }
    var add = e.target.closest && e.target.closest("[data-mt-up-add]");
    if (!add) return;
    e.preventDefault();
    add.closest(".mt-up").classList.add("is-loading");
    add.textContent = "…";
    mtProteccion(add.dataset.mtUpAdd, null, true, !!add.closest("cart-drawer"))
      .catch(function () { window.location.reload(); });
  });
  new MutationObserver(mtUpAplicar).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Ficha: bolsa de regalo (casilla + destinatario + mensaje) ---------- */
  document.addEventListener("change", function (e) {
    var cb = e.target.closest && e.target.closest("[data-mt-regalo-check]");
    if (!cb) return;
    var box = cb.closest("[data-mt-regalo]"), panel = box.querySelector(".mt-regalo__panel");
    box.classList.toggle("is-open", cb.checked);
    panel.hidden = !cb.checked;
    if (cb.checked) { var p = box.querySelector("[data-mt-regalo-para]"); if (p) setTimeout(function () { p.focus(); }, 50); }
  });
  document.addEventListener("input", function (e) {
    var t = e.target.closest && e.target.closest("[data-mt-regalo-msg]");
    if (!t) return;
    var c = t.closest("[data-mt-regalo]").querySelector("[data-mt-regalo-cuenta]");
    if (c) c.textContent = t.value.length + "/" + t.maxLength;
  });
  // Si la casilla está marcada, el perfume y la bolsa se agregan juntos
  document.addEventListener("submit", function (e) {
    var form = e.target;
    var pdp = form.closest && form.closest("[data-mt-pdp]");
    if (!pdp) return;
    var box = pdp.querySelector("[data-mt-regalo]"), cb = box && box.querySelector("[data-mt-regalo-check]");
    if (!cb || !cb.checked) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector("[type=submit]"), spin = form.querySelector(".loading__spinner");
    if (btn) { btn.setAttribute("aria-disabled", "true"); btn.classList.add("loading"); }
    if (spin) spin.classList.remove("hidden");
    var props = {};
    var para = box.querySelector("[data-mt-regalo-para]").value.trim(), msg = box.querySelector("[data-mt-regalo-msg]").value.trim();
    if (para) props[box.dataset.propPara || "Para"] = para;
    if (msg) props[box.dataset.propMsg || "Mensaje"] = msg;
    var fd = new FormData(form);
    var drawer = document.querySelector("cart-drawer");
    var body = { items: [
      { id: Number(fd.get("id")), quantity: Number(fd.get("quantity") || 1) },
      { id: Number(box.dataset.variant), quantity: 1, properties: props }
    ] };
    if (drawer) body.sections = "cart-drawer,cart-icon-bubble";
    fetch(window.routes.cart_add_url + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { alert(res.description); return; }
        if (drawer && res.sections && typeof drawer.renderContents === "function") {
          res.id = Number(fd.get("id"));
          drawer.classList.remove("is-empty");
          drawer.renderContents(res);
          cb.checked = false; box.classList.remove("is-open"); box.querySelector(".mt-regalo__panel").hidden = true;
          box.querySelector("[data-mt-regalo-para]").value = ""; box.querySelector("[data-mt-regalo-msg]").value = "";
        } else { window.location.href = window.routes.cart_url; }
      })
      .catch(function () { window.location.href = window.routes.cart_url; })
      .finally(function () {
        if (btn) { btn.removeAttribute("aria-disabled"); btn.classList.remove("loading"); }
        if (spin) spin.classList.add("hidden");
      });
  }, true);

  /* ---------- Producto: carrusel "También te puede gustar" ---------- */
  function initRelacionados(root) {
    (root || document).querySelectorAll("[data-mt-rel]").forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = "1";
      var track = el.querySelector("[data-mt-rel-track]"), max = parseInt(el.dataset.max, 10) || 16;
      function paso(dir) { var it = track.querySelector(".mt-rel__item"), gap = parseFloat(getComputedStyle(track).columnGap) || 0; var w = it ? it.getBoundingClientRect().width + gap : 300; var cont = el.querySelector(".mt-container"); var cs = cont ? getComputedStyle(cont) : null; var ancho = cont ? cont.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) : track.clientWidth; var n = Math.max(1, Math.floor((ancho + gap + 2) / w)); track.scrollBy({ left: dir * n * w, behavior: "smooth" }); }
      function flechas() {
        var p = el.querySelector("[data-mt-rel-prev]"), n = el.querySelector("[data-mt-rel-next]");
        if (p) p.disabled = track.scrollLeft < 4;
        if (n) n.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      el.querySelector("[data-mt-rel-prev]").addEventListener("click", function () { paso(-1); });
      el.querySelector("[data-mt-rel-next]").addEventListener("click", function () { paso(1); });
      track.addEventListener("scroll", function () { requestAnimationFrame(flechas); }, { passive: true });
      window.addEventListener("resize", flechas);
      flechas();
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var recos = doc.querySelectorAll("[data-mt-rel-recos] .mt-rel__item");
        if (!recos.length) return;
        var vistos = {}, lista = [];
        recos.forEach(function (it) { if (!vistos[it.dataset.h]) { vistos[it.dataset.h] = 1; lista.push(it); } });
        track.querySelectorAll(".mt-rel__item").forEach(function (it) { if (!vistos[it.dataset.h]) { vistos[it.dataset.h] = 1; lista.push(it); } });
        track.innerHTML = "";
        lista.slice(0, max).forEach(function (it) { track.appendChild(document.importNode(it, true)); });
        initReveals(track); flechas();
      }).catch(function () {});
    });
  }

  /* ---------- Producto: "Más de la marca" para marcas sin colección (carga por filtro) ---------- */
  function initMarca(root) {
    (root || document).querySelectorAll("[data-mt-marca-js]").forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = "1";
      var excl = (el.dataset.excluir || "").split(","), max = parseInt(el.dataset.max, 10) || 8;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html"), grid = el.querySelector(".mt-marca__grid"), n = 0;
        doc.querySelectorAll("[data-mt-lista] .mt-lista__item").forEach(function (it) {
          if (n >= max || it.dataset.h === el.dataset.actual || excl.indexOf(it.dataset.h) > -1 || it.dataset.disp !== "true") return;
          var card = document.importNode(it.firstElementChild, true);
          var pc = parseInt(el.dataset.pc, 10) || max, mov = parseInt(el.dataset.movil, 10) || max;
          if (n >= pc) card.classList.add("mt-solo-movil");
          if (n >= mov) card.classList.add("mt-solo-pc");
          grid.appendChild(card); n++;
        });
        if (n > 0) { el.hidden = false; var w = el.closest(".shopify-section"); if (w) w.classList.remove("mt-oculta"); initReveals(el); mtDots(); }
      }).catch(function () {});
    });
  }

  /* ---------- Colecciones: filtros de la columna izquierda abiertos (solo ordenador) ---------- */
  var mtFiltrosVistos = new WeakSet();
  function mtAbrirFiltros() {
    if (!window.matchMedia("(min-width: 990px)").matches) return;
    document.querySelectorAll("details.facets__disclosure-vertical").forEach(function (d) {
      if (mtFiltrosVistos.has(d)) return;
      mtFiltrosVistos.add(d);
      d.open = true;
    });
  }
  new MutationObserver(mtAbrirFiltros).observe(document.documentElement, { childList: true, subtree: true });
  mtAbrirFiltros();

  /* ---------- Bolsa de regalo: foto en grande sin salir de la página ---------- */
  function mtVisor(src, alt) {
    var dlg = document.getElementById("MtVisor");
    if (!dlg) {
      dlg = document.createElement("dialog");
      dlg.id = "MtVisor"; dlg.className = "mt-visor";
      dlg.innerHTML = '<button type="button" class="mt-visor__cerrar" aria-label="Cerrar">&times;</button><img alt="">';
      document.body.appendChild(dlg);
      dlg.addEventListener("click", function (e) { if (e.target === dlg || e.target.closest(".mt-visor__cerrar")) dlg.close(); });
    }
    var img = dlg.querySelector("img"); img.src = src; img.alt = alt || "";
    if (typeof dlg.showModal === "function") dlg.showModal(); else window.open(src, "_self");
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-mt-regalo-foto]");
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.dataset.src) mtVisor(b.dataset.src, b.getAttribute("aria-label"));
  }, true);

  /* ---------- Celular: puntitos de los carruseles 2×2 ---------- */
  function mtDots() {
    document.querySelectorAll(".mt-grid--carrusel").forEach(function (g) {
      var visibles = Array.prototype.filter.call(g.children, function (c) { return !c.classList.contains("mt-solo-pc"); }).length;
      var paginas = Math.ceil(visibles / 4);
      var d = g.nextElementSibling && g.nextElementSibling.classList.contains("mt-dots") ? g.nextElementSibling : null;
      if (paginas < 2) { if (d) d.remove(); return; }
      if (d && d.children.length === paginas) return;
      if (d) d.remove();
      d = document.createElement("div"); d.className = "mt-dots";
      for (var i = 0; i < paginas; i++) {
        var b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", "Página " + (i + 1));
        if (i === 0) b.classList.add("is-active");
        (function (i) { b.addEventListener("click", function () { var v = Array.prototype.filter.call(g.children, function (c) { return !c.classList.contains("mt-solo-pc"); }); var t = v[i * 4]; if (t) g.scrollTo({ left: t.offsetLeft - v[0].offsetLeft, behavior: "smooth" }); }); })(i);
        d.appendChild(b);
      }
      g.parentNode.insertBefore(d, g.nextSibling);
      if (!g.dataset.mtDots) {
        g.dataset.mtDots = "1";
        g.addEventListener("scroll", function () {
          var dd = g.nextElementSibling; if (!dd || !dd.classList.contains("mt-dots")) return;
          var v = Array.prototype.filter.call(g.children, function (c) { return !c.classList.contains("mt-solo-pc"); }); var paso = v[4] ? v[4].offsetLeft - v[0].offsetLeft : g.clientWidth; var p = Math.round(g.scrollLeft / (paso || 1));
          Array.prototype.forEach.call(dd.children, function (b, i) { b.classList.toggle("is-active", i === p); });
        }, { passive: true });
      }
    });
  }

  /* ---------- Portada: productos al azar (se sortean en cada visita) ---------- */
  function initAzar(root) {
    (root || document).querySelectorAll("[data-mt-azar]").forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = "1";
      var grid = el.querySelector("[data-mt-azar-grid]");
      var pc = parseInt(el.dataset.pc, 10) || 8, mov = parseInt(el.dataset.movil, 10) || 12, tope = Math.max(pc, mov);
      var total = Math.max(1, parseInt(el.dataset.paginas, 10) || 1), excl = (el.dataset.excluir || "").split(",");
      var recientes = el.dataset.modo === "recientes";
      var pags = recientes ? [1] : [], intentos = 0;
      while (!recientes && pags.length < Math.min(3, total) && intentos < 20) { var p = 1 + Math.floor(Math.random() * total); if (pags.indexOf(p) < 0) pags.push(p); intentos++; }
      Promise.all(pags.map(function (p) { return fetch(el.dataset.url + "&page=" + p).then(function (r) { return r.text(); }).catch(function () { return ""; }); }))
        .then(function (htmls) {
          var vistos = {}, lista = [];
          htmls.forEach(function (h) {
            new DOMParser().parseFromString(h, "text/html").querySelectorAll("[data-mt-lista] .mt-lista__item").forEach(function (it) {
              if (it.dataset.disp !== "true" || excl.indexOf(it.dataset.h) > -1 || vistos[it.dataset.h]) return;
              vistos[it.dataset.h] = 1; lista.push(it.firstElementChild);
            });
          });
          if (!recientes) for (var i = lista.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = lista[i]; lista[i] = lista[j]; lista[j] = t; }
          if (!lista.length) return;
          grid.innerHTML = "";
          lista.slice(0, tope).forEach(function (c, n) {
            var card = document.importNode(c, true);
            if (n >= pc) card.classList.add("mt-solo-movil");
            if (n >= mov) card.classList.add("mt-solo-pc");
            grid.appendChild(card);
          });
          initReveals(grid); mtDots();
        });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.nodeType === 1 ? e.target : document;
    initReveals(root);
    initHero(root);
    initQuiz(root);
    initManifiesto(root);
    initAcordeones(root);
    initProducto(root);
    initPestanas(root);
    initNotas(root);
    initRecos(root);
    initRelacionados(root);
    initMarca(root);
    mtDots();
    initAzar(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();

/* ---------- Carrito: avisar cambios (evento mt:carrito) y refrescar el cajón si Shopify agrega solo una parte ---------- */
(function () {
  function mtRefrescarCajon() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || typeof cajon.renderContents !== 'function') return;
    f0('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.item_count) return;
      return f0('/cart?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sec) {
        cajon.classList.remove('is-empty');
        cajon.renderContents({ sections: sec, id: c.items[0].variant_id });
      });
    }).catch(function () {});
  }
  var f0 = window.fetch;
  if (f0) window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = f0.apply(this, arguments);
    if (/\/cart\/add/.test(url)) p.then(function (r) { if (r && r.status === 422) setTimeout(mtRefrescarCajon, 100); });
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(function () { document.dispatchEvent(new CustomEvent("mt:carrito")); }, 150); });
    return p;
  };
})();
